<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>

  <form
    #df="ngForm"
    novalidate
    (keydown.enter)="onSearchStaffBalance()"
    class="formborder"
  >
    <div class="row m-0 col-md-12 p-0 align-items-center">
      <div class="col-md-2">
        <span class="required-lable">Date From</span>
        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="VoucherDateFrom"
            id="VoucherDateFrom"
            class="form-control input-text-css"
            [(ngModel)]="VoucherDateFrom"
            [min]="minDate"
            [max]="maxDate"
            required
            #refVoucherDateFrom="ngModel"
            (dateChange)="DateChange()"
            [ngClass]="{
              'is-invalid': df.submitted && refVoucherDateFrom.invalid,
              'alert-warning':
                refVoucherDateFrom.invalid &&
                (refVoucherDateFrom.dirty ||
                  refVoucherDateFrom.touched ||
                  refVoucherDateFrom.untouched)
            }"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
        <!-- <input
          name="VoucherDateFrom"
          [(ngModel)]="VoucherDateFrom"
          id="VoucherDateFrom"
          [minDate]="minDate"
          [maxDate]="maxDate"
          placeholder="Voucher From"
          (ngModelChange)="DateChange()"
          class="form-control input-text-css"
          bsDatepicker
          required
          #refVoucherDateFrom="ngModel"
          [ngClass]="{
            'is-invalid': df.submitted && refVoucherDateFrom.invalid,
            'alert-warning':
              refVoucherDateFrom.invalid &&
              (refVoucherDateFrom.dirty ||
                refVoucherDateFrom.touched ||
                refVoucherDateFrom.untouched)
          }"
        /> -->
      </div>
      <div class="col-md-2">
        <span class="required-lable">Date To</span>
        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker2"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="VoucherDateTo"
            id="VoucherDateTo"
            [min]="minDate"
            [max]="maxDate"
            class="form-control input-text-css"
            [(ngModel)]="VoucherDateTo"
            (dateChange)="DateChange()"
            required
            #refVoucherDateTo="ngModel"
            [ngClass]="{
              'is-invalid': df.submitted && refVoucherDateTo.invalid,
              'alert-warning':
                refVoucherDateTo.invalid &&
                (refVoucherDateTo.dirty ||
                  refVoucherDateTo.touched ||
                  refVoucherDateTo.untouched)
            }"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </div>
        <!-- <input
          name="VoucherDateTo"
          [(ngModel)]="VoucherDateTo"
          (ngModelChange)="DateChange()"
          id="VoucherDateTo"
          [minDate]="minDate"
          [maxDate]="maxDate"
          placeholder="Voucher To"
          class="form-control input-text-css"
          bsDatepicker
          required
          #refVoucherDateTo="ngModel"
          [ngClass]="{
            'is-invalid': df.submitted && refVoucherDateTo.invalid,
            'alert-warning':
              refVoucherDateTo.invalid &&
              (refVoucherDateTo.dirty ||
                refVoucherDateTo.touched ||
                refVoucherDateTo.untouched)
          }"
        /> -->
      </div>

      <div class="col-md-2 text-right mb-2">
        <button
          type="button"
          (click)="onSearchStaffBalance()"
          class="mt-3 btn font-size-12 button-btn"
          [disabled]="!df.form.valid"
        >
          Search
        </button>
      </div>
      <div class="col-md-3 ml-4 mt-3 text-right mb-2">
        <form action="" class="search-text">
          <div class="bg-light rounded rounded-pill shadow-sm">
            <div class="input-group">
              <input
                type="text"
                id="FilterInputSearch"
                (keyup)="applyFilter($event.target.value)"
                name="FilterInputSearch"
                placeholder="What're you searching for?"
                class="form-control border-0 bg-light mt-2"
              />
              <div class="input-group-append">
                <button
                  id="button-addon1"
                  type="submit"
                  class="btn btn-link text-primary"
                >
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </form>

  <div class="mt-3" [hidden]="!DataSource">
    <div class="">
      <div class="table-responsive">
        <mat-table
          [dataSource]="DataSource"
          matSort
          matTableExporter
          #exporter="matTableExporter"
          style="width: 100%; overflow: auto"
        >
          <ng-container matColumnDef="AccountId">
            <mat-header-cell
              
              class="grid-header"
              *matHeaderCellDef
              style="max-width: 1.25rem !important"
              >#</mat-header-cell
            >
            <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
              {{ i + 1 }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="width: 0px;"></mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Account_Name">
            <mat-header-cell
              
              class="grid-header"
              *matHeaderCellDef
              >Account Name</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell mw200">{{
              row.Account_Name
            }}</mat-cell>
            <mat-footer-cell
              *matFooterCellDef
              class="text-left grid-header mw200"
              >Total:</mat-footer-cell
            >
          </ng-container>

          <ng-container matColumnDef="OpeningBalance">
            <mat-header-cell
              
              class="grid-header"
              *matHeaderCellDef
              >OpeningBalance</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.OpeningBalance
            }}</mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">
              {{ calculateOPBalanceTotal() }}</mat-footer-cell
            >
          </ng-container>

          <ng-container matColumnDef="TranTypeDR">
            <mat-header-cell
              
              class="grid-header"
              *matHeaderCellDef
              >TranTypeDR</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.TranTypeDR
            }}</mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">
              {{ calculateTranTypeDRTotal() }}</mat-footer-cell
            >
          </ng-container>

          <ng-container matColumnDef="TranTypeCR">
            <mat-header-cell
              
              class="grid-header"
              *matHeaderCellDef
              >TranTypeCR</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.TranTypeCR
            }}</mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">
              {{ calculateTranTypeCRTotal() }}</mat-footer-cell
            >
          </ng-container>

          <ng-container matColumnDef="ClosingBalance">
            <mat-header-cell
              
              class="grid-header"
              *matHeaderCellDef
              >ClosingBalance</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.ClosingBalance
            }}</mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">
              {{ calculateCLBalanceTotal() }}</mat-footer-cell
            >
          </ng-container>

          <ng-container matColumnDef="Collection_Limit">
            <mat-header-cell
              
              class="grid-header"
              *matHeaderCellDef
              >Collection Limit</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.Collection_Limit
            }}</mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">
              </mat-footer-cell
            >
          </ng-container>

          <ng-container matColumnDef="ViewAction">
            <mat-header-cell
              
              class="grid-header text-center"
              *matHeaderCellDef
            >
              View Detail
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell text-center">
              <i
                class="fa fa-arrow-circle-right arrow-circle action-btn"
                (click)="goToDetail(row)"
                aria-label="true"
              ></i>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          <tr
            mat-footer-row
            class="sticky-footer fontcolor"
            *matFooterRowDef="displayedColumns; sticky: true"
            style="background: var(--theme-primary)"
          ></tr>
        </mat-table>

        <div class="row m-0 align-items-center">
          <div class="col-md-4">
            <button
              class="mt-3 btn font-size-12 button-btn"
              (click)="exportTable()"
            >
              <i
                class="fa fa-file-export mr-1"
                style="font-size: medium; cursor: pointer"
              ></i>
              Export
            </button>
          </div>
          <div class="col-md-8 mt-3">
            <mat-paginator
  #mainPaginator
  [pageSizeOptions]="[20, 50]"
  showFirstLastButtons
>
</mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade in"
  id="AccountingDetail"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div
    class="modal-dialog modal-dialog-centered"
    role="document"
    style="max-width: 71.25rem"
  >
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Staff Balance
        </h6>
        <button
          type="button"
          class="close"
          (click)="OnCloseAccountingDetail()"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><i class="far text-black fa-times-circle"></i
          ></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row m-0 col-md-12 p-0 mb-2">
          <div class="col-md-3 p-1">
            <select
              name="BalanceType"
              id="BalanceType"
              class="form-control input-text-css"
              [(ngModel)]="BalanceType"
              (change)="ChangeBalanceType()"
            >
              <option [value]="0">Annually</option>
              <option [value]="1">Monthly</option>
              <option [value]="2">Daily</option>
            </select>
          </div>
        </div>
        <div
          class="table-responsive"
          *ngIf="DivAnnualy"
          style="max-width: 100%; overflow: auto"
        >
          <table
            class="table-bordered"
            mat-table
            matSort
            [dataSource]="dataSourceAccount"
          >
            <ng-container matColumnDef="voucherid">
              <th  mat-header-cell *matHeaderCellDef>#</th>
              <td mat-cell *matCellDef="let row; let i = index">
                  {{ modalPaginator?.pageIndex * modalPaginator?.pageSize + (i + 1) }}

              </td>
              <th mat-footer-cell *matFooterCellDef></th>
            </ng-container>

            <ng-container matColumnDef="Voucher_Date">
              <th  mat-header-cell *matHeaderCellDef>
                Voucher Date
              </th>
              <td mat-cell *matCellDef="let row">{{ row.VoucherDate }}</td>
              <th mat-footer-cell *matFooterCellDef></th>
            </ng-container>

            <ng-container matColumnDef="Voucher_No">
              <th  mat-header-cell *matHeaderCellDef>
                Voucher No
              </th>
              <td mat-cell *matCellDef="let row">{{ row.Voucher_No }}</td>
              <th mat-footer-cell *matFooterCellDef></th>
            </ng-container>

            <ng-container matColumnDef="CaseNo">
              <th  mat-header-cell *matHeaderCellDef>Loan No</th>
              <td mat-cell *matCellDef="let row">{{ row.CaseNo }}</td>
              <th mat-footer-cell *matFooterCellDef></th>
            </ng-container>

            <ng-container matColumnDef="accHead">
              <th  mat-header-cell *matHeaderCellDef>
                A/C Head
              </th>
              <td mat-cell *matCellDef="let row">{{ row.accHead }}</td>
              <th mat-footer-cell *matFooterCellDef>Total</th>
            </ng-container>

            <ng-container matColumnDef="TranTypeDR">
              <th
                
                mat-header-cell
                *matHeaderCellDef
                class="text-right"
              >
                DR Amount
              </th>
              <td mat-cell *matCellDef="let row" class="text-right">
                {{ row.TranTypeDR }}
              </td>
              <th mat-footer-cell *matFooterCellDef class="text-right">
                {{ dataSourceAccount ? calculateACTranTypeDR() : "" }}
              </th>
            </ng-container>

            <ng-container matColumnDef="TranTypeCR">
              <th
                
                mat-header-cell
                *matHeaderCellDef
                class="text-right"
              >
                CR Amount
              </th>
              <td mat-cell *matCellDef="let row" class="text-right">
                {{ row.TranTypeCR }}
              </td>
              <th mat-footer-cell *matFooterCellDef class="text-right">
                {{ dataSourceAccount ? calculateACTranTypeCR() : "" }}
              </th>
            </ng-container>

            <ng-container matColumnDef="TranTypeTotal">
              <th
                
                mat-header-cell
                *matHeaderCellDef
                class="text-right"
              >
                Balance
              </th>
              <td mat-cell *matCellDef="let row" class="text-right">
                {{ row.TranTypeTotal }}
              </td>
              <th mat-footer-cell *matFooterCellDef class="text-right">
                {{ dataSourceAccount ? calculateACTranTypeTotal() : "" }}
              </th>
            </ng-container>

            <ng-container matColumnDef="Narration">
              <th  mat-header-cell *matHeaderCellDef>
                Narration
              </th>
              <td mat-cell *matCellDef="let row">{{ row.Narration }}</td>
              <th mat-footer-cell *matFooterCellDef></th>
            </ng-container>

            <ng-container matColumnDef="ViewAction">
              <th
                mat-header-cell
                
                class="grid-header"
                *matHeaderCellDef
              >
                View Detail
              </th>
              <td
                mat-cell
                *matCellDef="let row; let i = index"
                class="text-center"
              >
                <div *ngIf="row.accHead == 'Opening Balance'; else elseBlock">
                  &nbsp;
                </div>
                <ng-template #elseBlock>
                  <app-lms-voucher-view-model
                    [voucherid]="row.voucherid"
                    (close)="GetData($event)"
                    [index]="i"
                  >
                    <i
                      class="fa fa-arrow-circle-right arrow-circle action-btn"
                      aria-label="true"
                    ></i>
                  </app-lms-voucher-view-model>
                </ng-template>
              </td>
              <th mat-footer-cell *matFooterCellDef></th>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="displayedAccountColumns; sticky: true"
            ></tr>
            <tr
              mat-row
              [ngClass]="{ Row_Bold: row.accHead == 'Opening Balance' }"
              *matRowDef="let row; columns: displayedAccountColumns"
            ></tr>
            <tr
              mat-footer-row
              class="sticky-footer fontcolor"
              *matFooterRowDef="displayedAccountColumns; sticky: true"
            ></tr>
          </table>
        </div>
        <div
          class="row m-0 pt-2 pb-1"
          style="background: #fff"
          *ngIf="DivAnnualy"
        >
          <div class="col-md-12 p-0">
            <div class="d-flex flex-wrap align-items-center justify-content-between w-100 px-2">
              <button
                class="btn font-size-12 button-btn"
                (click)="exportTableDetailsAnnually()"
              >
                <i
                  class="fa fa-file-export mr-1"
                  style="font-size: medium; cursor: pointer"
                ></i>
                Export
              </button>

              <mat-paginator
                #modalPaginator
                [pageSizeOptions]="[20, 50]"
                showFirstLastButtons
              >
              </mat-paginator>
            </div>
          </div>
        </div>

        <div class="table-responsive" *ngIf="DivMonthly">
          <mat-table
            [dataSource]="dataSourceMonthly"
            matSort
            matTableExporter
            #exporter="matTableExporter"
            style="max-width: 100%; overflow: auto"
          >
            <ng-container matColumnDef="Id">
              <mat-header-cell
                
                class="grid-header"
                style="max-width: 3.75rem"
                *matHeaderCellDef
                >#</mat-header-cell
              >
              <mat-cell
                *matCellDef="let row; let i = index"
                class="grid-cell"
                style="max-width: 3.75rem; max-height: 0.3125rem"
              >
                  {{ modalPaginator?.pageIndex * modalPaginator?.pageSize + (i + 1) }}

              </mat-cell>
              <mat-footer-cell
                *matFooterCellDef
                style="max-width: 3.75rem"
              ></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="Month_Year">
              <mat-header-cell
                
                class="grid-header"
                *matHeaderCellDef
                >Month Year</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Month_Year }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="Account_Name">
              <mat-header-cell
                
                class="grid-header"
                *matHeaderCellDef
              >
                Account Head
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Account_Name }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="accHead">
              <mat-header-cell
                
                class="grid-header"
                *matHeaderCellDef
                >Account Head</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.accHead }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>Total:</mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="TranTypeDR">
              <mat-header-cell
                
                class="grid-header"
                *matHeaderCellDef
                >DR Amount</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.TranTypeDR }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                {{ dataSourceMonthly ? totaltypeMonthly("TranTypeDR") : "" }}
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="TranTypeCR">
              <mat-header-cell
                
                class="grid-header"
                *matHeaderCellDef
                >CR Amount</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.TranTypeCR }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                {{ dataSourceMonthly ? totaltypeMonthly("TranTypeCR") : "" }}
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="TranTypeTotal">
              <mat-header-cell
                
                class="grid-header"
                *matHeaderCellDef
                >Balance</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.TranTypeTotal }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                {{ dataSourceMonthly ? calculateMonthlyBalance() : "" }}
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="Action">
              <mat-header-cell
                
                class="grid-header"
                style="max-width: 6.25rem; justify-content: center"
                *matHeaderCellDef
              >
                View Detail
              </mat-header-cell>
              <mat-cell
                *matCellDef="let row; let i = index"
                class="grid-cell text-center"
                style="max-width: 6.25rem"
              >
                <div
                  *ngIf="row.Account_Name == 'Opening Balance'; else elseBlock"
                >
                  &nbsp;
                </div>
                <ng-template #elseBlock>
                  <app-lms-voucher-view-model
                    [voucherid]="row.voucherid"
                    (close)="GetData($event)"
                    [index]="i"
                  >
                    <i
                      class="fa fa-arrow-circle-right arrow-circle action-btn"
                      aria-label="true"
                    ></i>
                  </app-lms-voucher-view-model>
                </ng-template>
              </mat-cell>
              <mat-footer-cell
                *matFooterCellDef
                style="max-width: 6.25rem"
              ></mat-footer-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumnsMonthly; sticky: true"
            ></mat-header-row>
            <mat-row
              [ngClass]="{ Row_Bold: row.Account_Name == 'Opening Balance' }"
              *matRowDef="let row; columns: displayedColumnsMonthly"
            ></mat-row>
            <mat-footer-row
              class="sticky-footer fontcolor"
              *matFooterRowDef="displayedColumnsMonthly; sticky: true"
              style="background: var(--theme-primary)"
            ></mat-footer-row>
          </mat-table>
        </div>

        <div
          class="row m-0 pt-2 pb-1"
          style="background: #fff"
          [hidden]="!DivMonthly"
        >
          <div
            class="col-md-12 text-right"
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <div class="col-md-4 text-left">
              <button
                class="btn font-size-12 button-btn"
                (click)="exportTableDetailsMontlhy()"
              >
                <i
                  class="fa fa-file-export mr-1"
                  style="font-size: medium; cursor: pointer"
                ></i>
                Export
              </button>
            </div>

            <div class="col-md-8">
              <mat-paginator
  #modalPaginator
  [pageSizeOptions]="[20, 50]"
  showFirstLastButtons
>
</mat-paginator>
            </div>
          </div>
        </div>

        <div class="table-responsive" *ngIf="DivDaily">
          <mat-table
            [dataSource]="dataSourceDaily"
            matSort
            matTableExporter
            #exporter="matTableExporter"
            style="max-width: 100%; overflow: auto"
          >
            <ng-container matColumnDef="Id">
              <mat-header-cell
                
                class="grid-header"
                style="max-width: 3.75rem"
                *matHeaderCellDef
                >#</mat-header-cell
              >
              <mat-cell
                *matCellDef="let row; let i = index"
                class="grid-cell"
                style="max-width: 3.75rem; max-height: 0.3125rem"
              >
                  {{ modalPaginator?.pageIndex * modalPaginator?.pageSize + (i + 1) }}

              </mat-cell>
              <mat-footer-cell
                *matFooterCellDef
                style="max-width: 3.75rem"
              ></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="Account_Name">
              <mat-header-cell
                
                class="grid-header"
                *matHeaderCellDef
              >
                Account Head
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Account_Name }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="VoucherDate">
              <mat-header-cell
                
                class="grid-header"
                *matHeaderCellDef
                >Voucher Date</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Voucher_Date | date }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>Total:</mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="TranTypeDR">
              <mat-header-cell
                
                class="grid-header"
                *matHeaderCellDef
                >DR Amount</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.TranTypeDR }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                {{ dataSourceDaily ? totaltypeDaily("TranTypeDR") : "" }}
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="TranTypeCR">
              <mat-header-cell
                
                class="grid-header"
                *matHeaderCellDef
                >CR Amount</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.TranTypeCR }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                {{ dataSourceDaily ? totaltypeDaily("TranTypeCR") : "" }}
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="TranTypeTotal">
              <mat-header-cell
                
                class="grid-header"
                *matHeaderCellDef
                >Balance</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.TranTypeTotal }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                {{ dataSourceDaily ? calculateDailyBalance() : "" }}
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="Action">
              <mat-header-cell
                
                class="grid-header"
                style="max-width: 6.25rem; justify-content: center"
                *matHeaderCellDef
              >
                View Detail
              </mat-header-cell>
              <mat-cell
                *matCellDef="let row; let i = index"
                class="grid-cell text-center"
                style="max-width: 6.25rem"
              >
                <div
                  *ngIf="row.Account_Name == 'Opening Balance'; else elseBlock"
                >
                  &nbsp;
                </div>
                <ng-template #elseBlock>
                   <app-lms-voucher-view-model
                    [voucherid]="row.voucherid"
                    (close)="GetData($event)"
                    [index]="i"
                  >
                    <i
                      class="fa fa-arrow-circle-right arrow-circle action-btn"
                      aria-label="true"
                    ></i>
                  </app-lms-voucher-view-model>
                </ng-template>
              </mat-cell>
              <mat-footer-cell
                *matFooterCellDef
                style="max-width: 6.25rem"
              ></mat-footer-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumnsDaily; sticky: true"
            ></mat-header-row>
            <mat-row
              [ngClass]="{ Row_Bold: row.Account_Name == 'Opening Balance' }"
              *matRowDef="let row; columns: displayedColumnsDaily"
            ></mat-row>
            <mat-footer-row
              class="sticky-footer fontcolor"
              *matFooterRowDef="displayedColumnsDaily; sticky: true"
              style="background: var(--theme-primary)"
            ></mat-footer-row>
          </mat-table>
        </div>

        <div
          class="row m-0 pt-2 pb-1"
          style="background: #fff"
          [hidden]="!DivDaily"
        >
          <div
            class="col-md-12 text-right"
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <div class="col-md-4 text-left">
              <button
                class="btn font-size-12 button-btn"
                (click)="exportTableDetailsDaily()"
              >
                <i
                  class="fa fa-file-export mr-1"
                  style="font-size: medium; cursor: pointer"
                ></i>
                Export
              </button>
            </div>

            <div class="col-md-8">
              <mat-paginator
  #modalPaginator
  [pageSizeOptions]="[20, 50]"
  showFirstLastButtons
>
</mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<table
  id="staff_balance"
  class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none"
>
  <tr>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">#</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Account Name
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Opening Balance
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      TranType DR
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      TranType CR
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Closing Balance
    </th>
  </tr>

  <tr *ngFor="let x of FileCheckingList; let i = index">
    <td>{{ i + 1 }}</td>
    <td>{{ x.Account_Name }}</td>
    <td>{{ x.OpeningBalance }}</td>
    <td>{{ x.TranTypeDR }}</td>
    <td>{{ x.TranTypeCR }}</td>

    <td>{{ x.ClosingBalance }}</td>
  </tr>

  <tfoot>
    <tr>
      <td
        colspan="2"
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        <b>Total:</b>
      </td>
      <td
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        {{ calculateOPBalanceTotal() }}
      </td>
      <td
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        <strong>{{ calculateTranTypeDRTotal() }}</strong>
      </td>
      <td
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        <strong> {{ calculateTranTypeCRTotal() }} </strong>
      </td>

      <td
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        <strong>{{ calculateCLBalanceTotal() }}</strong>
      </td>
    </tr>
  </tfoot>
</table>

<table
  id="staff_balance_details_annually"
  class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none"
>
  <tr>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">#</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Voucher Date
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Voucher No.
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Loan No.
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Account Head
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      DR Amount
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      CR Amount
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Balance
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Narration
    </th>
  </tr>

  <tr *ngFor="let x of FileCheckingList; let i = index">
    <td>{{ i + 1 }}</td>
    <td>{{ x.VoucherDate }}</td>
    <td>{{ x.Voucher_No }}</td>
    <td>{{ x.CaseNo }}</td>
    <td>{{ x.accHead }}</td>
    <td>{{ x.TranTypeDR }}</td>
    <td>{{ x.TranTypeCR }}</td>
    <td>{{ x.TranTypeTotal }}</td>
    <td>{{ x.Narration }}</td>
  </tr>

  <tfoot>
    <tr>
      <td
        colspan="5"
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        <b>Total:</b>
      </td>
      <td
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        {{ dataSourceAccount ? calculateACTranTypeDR() : "" }}
      </td>
      <td
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        <strong>{{ dataSourceAccount ? calculateACTranTypeCR() : "" }}</strong>
      </td>

      <td
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        <strong>{{
          dataSourceAccount ? calculateACTranTypeTotal() : ""
        }}</strong>
      </td>
      <td
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      ></td>
    </tr>
  </tfoot>
</table>

<table
  id="staff_balance_details_monthly"
  class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none"
>
  <tr>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">#</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Month Year
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Account Head
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      DR Amount
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      CR Amount
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Balance
    </th>
  </tr>

  <tr *ngFor="let x of FileCheckingListMonthly; let i = index">
    <td>{{ i + 1 }}</td>
    <td>{{ x.Month_Year }}</td>
    <td>{{ x.Account_Name }}</td>
    <td>{{ x.TranTypeDR }}</td>
    <td>{{ x.TranTypeCR }}</td>
    <td>{{ x.TranTypeTotal }}</td>
  </tr>

  <tfoot>
    <tr>
      <td
        colspan="3"
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        <b>Total:</b>
      </td>
      <td
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        {{ dataSourceMonthly ? totaltypeMonthly("TranTypeDR") : "" }}
      </td>
      <td
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        {{ dataSourceMonthly ? totaltypeMonthly("TranTypeCR") : "" }}
      </td>
      <td
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        <strong>
          {{ dataSourceMonthly ? calculateMonthlyBalance() : "" }}</strong
        >
      </td>
    </tr>
  </tfoot>
</table>

<table
  id="staff_balance_details_daily"
  class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none"
>
  <tr>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">#</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Voucher Date
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Account Head
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      DR Amount
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      CR Amount
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Balance
    </th>
  </tr>

  <tr *ngFor="let x of FileCheckingListDaily; let i = index">
    <td>{{ i + 1 }}</td>
    <td>{{ x.Voucher_Date | date }}</td>
    <td>{{ x.Account_Name }}</td>
    <td>{{ x.TranTypeDR }}</td>
    <td>{{ x.TranTypeCR }}</td>
    <td>{{ x.TranTypeTotal }}</td>
  </tr>

  <tfoot>
    <tr>
      <td
        colspan="3"
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        <b>Total:</b>
      </td>
      <td
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        {{ dataSourceDaily ? totaltypeDaily("TranTypeDR") : "" }}
      </td>
      <td
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        {{ dataSourceDaily ? totaltypeDaily("TranTypeCR") : "" }}
      </td>
      <td
        style="
          background: var(--theme-primary) !important;
          border: 1px solid black;
          text-align: right;
        "
      >
        {{ dataSourceDaily ? calculateDailyBalance() : "" }}
      </td>
    </tr>
  </tfoot>
</table>
